import styled from 'styled-components';

export const StyledDateContainer = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  justify-content: space-between;
  color: #000000;
  width: 100%;
  & > div {
    width: 48%;
  }

  @media (max-width: 575px) {
    flex-direction: column;

    & > div {
      width: 100%;
      & > div {
        width: 100%;
      }
    }
  }
`;

export const StyledTimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  & .drop-down {
    width: 47%;
  }
  & span {
    width: 80px;
  }
`;
